import { render } from "./LinkContent.vue?vue&type=template&id=2f89da8a"
import script from "./LinkContent.vue?vue&type=script&lang=js"
export * from "./LinkContent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__